export const getConsultData = (store) => store.consultform.editData;
